"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAudioResponse = getAudioResponse;
const plugin_audio_keyboard_response_1 = __importDefault(require("@jspsych/plugin-audio-keyboard-response"));
const taskStore_1 = require("../../../taskStore");
function getAudioResponse(mediaAssets) {
    return {
        type: plugin_audio_keyboard_response_1.default,
        stimulus: () => {
            if ((0, taskStore_1.taskStore)().audioFeedback === 'binary' && (0, taskStore_1.taskStore)().isCorrect) {
                return mediaAssets.audio.coin;
            }
            if ((0, taskStore_1.taskStore)().audioFeedback === 'binary' && !(0, taskStore_1.taskStore)().isCorrect) {
                return mediaAssets.audio.fail;
            }
            // neutral case
            return mediaAssets.audio.select;
        },
        choices: 'NO_KEYS',
        trial_ends_after_audio: true,
        post_trial_gap: 500,
        prompt: '',
    };
}
